<div id="contact">
    <section class="contact-page-section">
        <div class="container">
            <div class="sec-title">
                <div class="title">Contact Us</div>
                <h2>Let's Get in Touch</h2>
            </div>

            <div class="inner-container">
                <div class="row clearfix">
                    <!-- Form Column -->
                    <div class="form-column col-md-8 col-sm-12 col-xs-12">
                        <div class="inner-column">
                            <div class="contact-form">
                                <!-- Contact Form (static / no backend) -->
                                <form class="row g-3 needs-validation" novalidate>
                                    <div class="row clearfix">
                                        <div class="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input type="text" placeholder="Name" name="name" id="name" required />
                                        </div>

                                        <div class="form-group col-md-6 col-sm-6 co-xs-12">
                                            <input placeholder="Phone" type="tel" name="phone" id="phone" required />
                                        </div>

                                        <div class="form-group col-md-12 col-sm-6 co-xs-12">
                                            <input type="email" placeholder="Email" name="email" id="email" required />
                                        </div>

                                        <div class="form-group col-md-12 col-sm-12 co-xs-12">
                                            <textarea placeholder="Message" name="message" id="message"
                                                required></textarea>
                                        </div>

                                        <div class="form-group col-md-12 col-sm-12 co-xs-12">
                                            <button type="submit" class="theme-btn btn-style-one">
                                                Send Now
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <!-- Info Column -->
                    <div class="info-column col-md-4 col-sm-12 col-xs-12">
                        <div class="inner-column">
                            <h2>Contact Info</h2>
                            <ul class="list-info">
                                <li class="text-uppercase">
                                    <i class="fas fa-globe"></i> Shah Satnam Ji Girls' College<br />
                                    Near Shah Satnam Ji Speciality Hospital<br />
                                    Bhadra Road, Sirsa, Haryana 125055
                                </li>

                                <li>
                                    <i class="far fa-envelope"></i>
                                    ssji1525@gmail.com <br />
                                    ssgians1@gmail.com
                                </li>

                                <li>
                                    <i class="fas fa-phone"></i> +91 9729458602<br />
                                    <i class="fa-solid fa-blender-phone"></i> 01666-238602
                                </li>

                                <li>
                                    <i class="fa-regular fa-eye"></i> Total Visitors:
                                </li>
                            </ul>

                            <ul class="social-icon-four">
                                <li class="follow">Follow us:</li>
                                <li>
                                    <a href="https://www.facebook.com/shahsatnamjigirlscollegesirsa/" target="_blank"><i
                                            class="fab fa-facebook-f"></i></a>
                                </li>
                                <li>
                                    <a href="https://x.com/ssjgcsirsa1997/" target="_blank"><i
                                            class="fa-brands fa-x-twitter"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/shahsatnamjigirlscollegesirsa?igsh=MW9veGtwc3d2ZDlpNA=="
                                        target="_blank"><i class="fab fa-instagram"></i></a>
                                </li>
                                <li>
                                    <a href="https://share.google/ZV5w2ThpVrjKGe8H5"
                                        target="_blank"><i class="fab fa-threads"></i></a>
                                </li>
                                <li>
                                    <a href="https://maps.app.goo.gl/xnt7C9SafCdcE7g78" target="_blank"><i
                                            class="fa-solid fa-map-pin"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCZSxE3ywZQA_xXVbNP3vSFw"
                                        target="_blank"><i class="fab fa-youtube"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Map Embed -->
                <div class="row mt-5">
                    <div class="col-12">
                        <iframe src="https://www.google.com/maps?q=Shah+Satnam+Ji+Girls'+College+Sirsa&output=embed"
                            width="100%" height="400" style="border: 0;" allowfullscreen="" loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
